var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Lorem ipsum dolor sit, amet consectetur adipisicing elit. Quidem deserunt fugit ea nobis porro libero illum consequatur. Nesciunt odio dolore, animi adipisci, earum inventore maxime expedita quam perferendis, aliquam eaque. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }